import { useQuery } from "@apollo/react-hooks";

import GetFullAddressQuery from "../graph-ql/GetFullAddress.graphql";

const useQueryGetFullAddress = (id: string) =>
  useQuery(GetFullAddressQuery, {
    variables: { id: id || "" },
    skip: !id,
  });

export default useQueryGetFullAddress;
